/**
 * Безопасно открывает внешнюю ссылку в новом окне/вкладке
 * @param url - URL для открытия
 * @param target - Где откроется ссылка(по умолчанию '_blank')
 */
export const openExternalLink = (url?: string, target: string = '_blank'): void => {
    if (!url) {
        return;
    }
    const link = document.createElement('a');
    link.href = url;
    link.target = target;
    link.rel = 'noopener noreferrer';
    link.click();
};
